/**
 * Iterate all items to mark an action with done.
 *
 * @param {Array} items
 *   The items from the state.
 * @param {string} id
 *   ID of item to update.
 * @param {boolean} action
 *   Action to set.
 *
 * @return {Array}
 *   A new array of items.
 */
export const markNotificationWithAction = (items, id, action) => {
    const newItems = [];
    items.forEach((item) => {
        const newItem = Object.assign({}, item);
        if (item.id === id) {
            newItem.action_done = action;
        }
        newItems.push(newItem);
    });
    return newItems;
};
/**
 * Iterate all items to mark an action without an action as read.
 *
 * @param {Array} items
 *   Current notifications on state.
 * @param {number} id
 *   ID of the notification to mark.
 *
 * @return {Array}
 *   New array of notifications.
 */
export const markNotificationAsRead = (items, id) => {
    const newItems = [];
    items.forEach((item) => {
        const newItem = Object.assign({}, item);
        if (item.id === id
            && !newItem.action_key
            || (newItem.action_key && typeof newItem.action_done !== 'undefined')) {
            newItem.is_read = true;
        }
        newItems.push(newItem);
    });
    return newItems;
};
const notificationsReducer = (state = { isLoading: true, items: [] }, action) => {
    switch (action.type) {
        case 'NOTIFICATION_REQUESTED':
            return Object.assign(Object.assign({}, state), { isLoadingNotification: action.id });
        case 'NOTIFICATION_RECEIVED':
            return Object.assign(Object.assign({}, state), { isLoading: false, items: action.notifications });
        case 'NOTIFICATION_DISPATCHED': {
            // Mark the action done.
            let updatedItems = markNotificationWithAction(state.items, action.itemId, action.action);
            // Mark notification as read.
            updatedItems = markNotificationAsRead(updatedItems, action.itemId);
            return Object.assign(Object.assign({}, state), { items: updatedItems });
        }
        case 'NOTIFICATION_TOGGLE': {
            return Object.assign(Object.assign({}, state), { isLoadingNotification: false, items: markNotificationAsRead(state.items, action.item.id), modalItemId: action.item.id });
        }
        case 'NOTIFICATION_LIST_TOGGLE': {
            return Object.assign(Object.assign({}, state), { showItems: !state.showItems });
        }
        default:
            return state;
    }
};
export default notificationsReducer;
